"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DISPLAY_TYPES = void 0;

var _luxon = require("luxon");

var _ = require(".");

var DISPLAY_TYPES = {
  EPG: 'EPG',
  PERCENTAGE: 'PERCENTAGE',
  PRESENCE_OF: 'PRESENCE_OF'
};
exports.DISPLAY_TYPES = DISPLAY_TYPES;

var TestType =
/** @class */
function () {
  function TestType() {
    this.id = null;
    this.name = null;
    this.isDemo = null;
    this.isActive = null;
    this.showEggsCounted = null;
    this.isComingSoon = null;
    this.displayType = null;
    this.imageDetectionUrl = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.parasiteSpecies = null;
    this.animalSpecies = null;
    this.recipes = null;
    this.inventoryTypes = null;
    this.testKitId = null;
    this.testKit = null;
    this.correctionFactor = null;
    this.count = null;
    this.order = null;
    this.isIndependentType = null;
    this.isResultsType = null;
    this.parentTestTypeId = null;
    this.parentTestType = null;
    this.hasIncubation = null;
    this.jointChildTestTypes = null;
    this.TestTypeJoin = null;
    this.childTestTypes = null;
    this.zIndex = null;
    this.testTypeGroup = null;
  }

  TestType.thaw = function (testTypeObj) {
    var _a, _b;

    if (testTypeObj == null) return null;
    var testType = new TestType();

    if (testTypeObj.id != null) {
      testType.setId(testTypeObj.id);
    }

    if (testTypeObj.name != null) {
      testType.setName(testTypeObj.name);
    }

    if (testTypeObj.isDemo != null) {
      testType.setIsDemo(testTypeObj.isDemo);
    }

    if (testTypeObj.isActive != null) {
      testType.setIsActive(testTypeObj.isActive == null ? null : testTypeObj.isActive ? true : false);
    }

    if (testTypeObj.showEggsCounted != null) {
      testType.setIsComingSoon(testTypeObj.showEggsCounted);
    }

    if (testTypeObj.isComingSoon != null) {
      testType.setIsComingSoon(testTypeObj.isComingSoon);
    }

    if (testTypeObj.displayType != null) {
      testType.setDisplayType(testTypeObj.displayType);
    }

    if (testTypeObj.imageDetectionUrl != null) {
      testType.setImageDetectionUrl(testTypeObj.imageDetectionUrl);
    }

    if (testTypeObj.createdAt != null) {
      testType.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testTypeObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (testTypeObj.updatedAt != null) {
      testType.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(testTypeObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (testTypeObj.parasiteSpecies != null) {
      testType.setParasiteSpecies(_.ParasiteSpecies.thawList(testTypeObj.parasiteSpecies));
    }

    if (testTypeObj.animalSpecies != null) {
      testType.setAnimalSpecies(_.AnimalSpecies.thawList(testTypeObj.animalSpecies));
    }

    if (testTypeObj.recipes != null) {
      testType.setRecipes(_.Recipe.thawList(testTypeObj.recipes));
    }

    if (testTypeObj.inventoryTypes != null) {
      testType.setInventoryTypes(_.InventoryType.thawList(testTypeObj.inventoryTypes));
    }

    if (testTypeObj.testKitId != null) {
      testType.setTestKitId(testTypeObj.testKitId);
    }

    if (testTypeObj.testKit != null) {
      testType.setTestKit(_.InventoryType.thaw(testTypeObj.testKit));
    }

    if (testTypeObj.correctionFactor != null) {
      testType.setCorrectionFactor(testTypeObj.correctionFactor);
    }

    if (testTypeObj.count != null) {
      testType.setCount(testTypeObj.count);
    }

    if (testTypeObj.order != null) {
      testType.setOrder(testTypeObj.order);
    }

    if (testTypeObj.isIndependentType != null) {
      testType.setIsIndependentType(testTypeObj.isIndependentType);
    }

    if (testTypeObj.isResultsType != null) {
      testType.setIsResultsType(testTypeObj.isResultsType);
    }

    if (testTypeObj.parentTestTypeId != null) {
      testType.setParentTestTypeId(testTypeObj.parentTestTypeId);
    }

    if (testTypeObj.parentTestType != null) {
      testType.setParentTestType(TestType.thaw(testTypeObj.parentTestType));
    }

    if (testTypeObj.hasIncubation != null) {
      testType.setHasIncubation(testTypeObj.hasIncubation);
    }

    if (testTypeObj.jointChildTestTypes != null) {
      testType.setJointChildTestTypes(TestType.thawList(testTypeObj.jointChildTestTypes));
    }

    if (testTypeObj.TestTypeJoin != null) {
      testType.setTestTypeJoin(_.TestTypeJoin.thaw(testTypeObj.TestTypeJoin));
    }

    if (testTypeObj.childTestTypes != null) {
      testType.setChildTestTypes(TestType.thawList(testTypeObj.childTestTypes));
    }

    if (testTypeObj.zIndex != null) {
      testType.setZIndex(testTypeObj.zIndex);
    }

    if (testTypeObj.testTypeGroup != null) {
      testType.setTestTypeGroup(_.TestTypeGroup.thaw(testTypeObj.testTypeGroup));
    }

    return testType;
  };

  TestType.thawList = function (testTypeObjList) {
    if (testTypeObjList == null) {
      return [];
    }

    var testTypes = [];

    for (var i = 0; i < testTypeObjList.length; i++) {
      testTypes.push(TestType.thaw(testTypeObjList[i]));
    }

    return testTypes;
  };

  TestType.freeze = function (testType) {
    var _a, _b, _c, _d;

    if (testType == null) {
      return null;
    }

    var testTypeObj = {};

    if (testType.getId() != null) {
      testTypeObj.id = testType.getId();
    }

    if (testType.getName() != null) {
      testTypeObj.name = testType.getName();
    }

    if (testType.getIsDemo() != null) {
      testTypeObj.isDemo = testType.getIsDemo();
    }

    if (testType.getIsActive() != null) {
      testTypeObj.isActive = testType.getIsActive() == null ? null : testType.getIsActive() ? 1 : 0;
    }

    if (testType.getShowEggsCounted() != null) {
      testTypeObj.showEggsCounted = testType.getShowEggsCounted();
    }

    if (testType.getIsComingSoon() != null) {
      testTypeObj.isComingSoon = testType.getIsComingSoon();
    }

    if (testType.getDisplayType() != null) {
      testTypeObj.displayType = testType.getDisplayType();
    }

    if (testType.getDisplayType() != null) {
      testTypeObj.imageDetectionUrl = testType.getDisplayType();
    }

    if (testType.getCreatedAt() != null) {
      testTypeObj.createdAt = (_b = (_a = testType.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (testType.getUpdatedAt() != null) {
      testTypeObj.updatedAt = (_d = (_c = testType.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (testType.getParasiteSpecies() != null) {
      testTypeObj.parasiteSpecies = _.ParasiteSpecies.freezeList(testType.getParasiteSpecies());
    }

    if (testType.getAnimalSpecies() != null) {
      testTypeObj.animalSpecies = _.AnimalSpecies.freezeList(testType.getAnimalSpecies());
    }

    if (testType.getRecipes() != null) {
      testTypeObj.recipes = _.Recipe.freezeList(testType.getRecipes());
    }

    if (testType.getInventoryTypes() != null) {
      testTypeObj.inventoryTypes = _.InventoryType.freezeList(testType.getInventoryTypes());
    }

    if (testType.getTestKitId() != null) {
      testTypeObj.testKitId = testType.getTestKitId();
    }

    if (testType.getTestKit() != null) {
      testTypeObj.testKit = _.InventoryType.freeze(testType.getTestKit());
    }

    if (testType.getCorrectionFactor() != null) {
      testTypeObj.correctionFactor = testType.getCorrectionFactor();
    }

    if (testType.getCount() != null) {
      testTypeObj.count = testType.getCount();
    }

    if (testType.getOrder() != null) {
      testTypeObj.order = testType.getOrder();
    }

    if (testType.getIsIndependentType() != null) {
      testTypeObj.isIndependentType = testType.getIsIndependentType();
    }

    if (testType.getIsResultsType() != null) {
      testTypeObj.isResultsType = testType.getIsResultsType();
    }

    if (testType.getParentTestTypeId() != null) {
      testTypeObj.parentTestTypeId = testType.getParentTestTypeId();
    }

    if (testType.getParentTestType() != null) {
      testTypeObj.parentTestType = TestType.freeze(testType.getParentTestType());
    }

    if (testType.getHasIncubation() != null) {
      testTypeObj.hasIncubation = testType.getHasIncubation();
    }

    if (testType.getJointChildTestTypes() != null) {
      testTypeObj.jointChildTestTypes = TestType.freezeList(testType.getJointChildTestTypes());
    }

    if (testType.getTestTypeJoin() != null) {
      testTypeObj.TestTypeJoin = _.TestTypeJoin.freeze(testType.getTestTypeJoin());
    }

    if (testType.getChildTestTypes() != null) {
      testTypeObj.childTestTypes = TestType.freezeList(testType.getChildTestTypes());
    }

    if (testType.getZIndex() != null) {
      testTypeObj.zIndex = testType.getZIndex();
    }

    if (testType.getTestTypeGroup() != null) {
      testTypeObj.testTypeGroup = _.TestTypeGroup.freeze(testType.getTestTypeGroup());
    }

    return testTypeObj;
  };

  TestType.freezeList = function (testTypes) {
    if (testTypes == null) {
      return [];
    }

    var testTypeObjList = [];

    for (var i = 0; i < testTypes.length; i++) {
      testTypeObjList.push(TestType.freeze(testTypes[i]));
    }

    return testTypeObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  TestType.prototype.setId = function (id) {
    this.id = id;
  };

  TestType.prototype.setName = function (name) {
    this.name = name;
  };

  TestType.prototype.setIsDemo = function (isDemo) {
    this.isDemo = isDemo;
  };

  TestType.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };

  TestType.prototype.setShowEggsCounted = function (showEggsCounted) {
    this.showEggsCounted = showEggsCounted;
  };

  TestType.prototype.setIsComingSoon = function (isComingSoon) {
    this.isComingSoon = isComingSoon;
  };

  TestType.prototype.setDisplayType = function (displayType) {
    this.displayType = displayType;
  };

  TestType.prototype.setImageDetectionUrl = function (imageDetectionUrl) {
    this.imageDetectionUrl = imageDetectionUrl;
  };

  TestType.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  TestType.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  TestType.prototype.setParasiteSpecies = function (parasiteSpecies) {
    this.parasiteSpecies = parasiteSpecies;
  };

  TestType.prototype.setAnimalSpecies = function (animalSpecies) {
    this.animalSpecies = animalSpecies;
  };

  TestType.prototype.setRecipes = function (recipes) {
    this.recipes = recipes;
  };

  TestType.prototype.setInventoryTypes = function (inventoryTypes) {
    this.inventoryTypes = inventoryTypes;
  };

  TestType.prototype.setTestKitId = function (testKitId) {
    this.testKitId = testKitId;
  };

  TestType.prototype.setTestKit = function (testKit) {
    this.testKit = testKit;
  };

  TestType.prototype.setCorrectionFactor = function (correctionFactor) {
    this.correctionFactor = correctionFactor;
  };

  TestType.prototype.setCount = function (count) {
    this.count = count;
  };

  TestType.prototype.setOrder = function (order) {
    this.order = order;
  };

  TestType.prototype.setIsIndependentType = function (isIndependentType) {
    this.isIndependentType = isIndependentType;
  };

  TestType.prototype.setIsResultsType = function (isResultsType) {
    this.isResultsType = isResultsType;
  };

  TestType.prototype.setParentTestTypeId = function (parentTestTypeId) {
    this.parentTestTypeId = parentTestTypeId;
  };

  TestType.prototype.setParentTestType = function (parentTestType) {
    this.parentTestType = parentTestType;
  };

  TestType.prototype.setHasIncubation = function (hasIncubation) {
    this.hasIncubation = hasIncubation;
  };

  TestType.prototype.setJointChildTestTypes = function (jointChildTestTypes) {
    this.jointChildTestTypes = jointChildTestTypes;
  };

  TestType.prototype.setTestTypeJoin = function (TestTypeJoin) {
    this.TestTypeJoin = TestTypeJoin;
  };

  TestType.prototype.setChildTestTypes = function (childTestTypes) {
    this.childTestTypes = childTestTypes;
  };

  TestType.prototype.setZIndex = function (zIndex) {
    this.zIndex = zIndex;
  };

  TestType.prototype.setTestTypeGroup = function (testTypeGroup) {
    this.testTypeGroup = testTypeGroup;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  TestType.prototype.getId = function () {
    return this.id;
  };

  TestType.prototype.getName = function () {
    return this.name;
  };

  TestType.prototype.getIsDemo = function () {
    return this.isDemo;
  };

  TestType.prototype.getIsActive = function () {
    return this.isActive;
  };

  TestType.prototype.getShowEggsCounted = function () {
    return this.showEggsCounted;
  };

  TestType.prototype.getIsComingSoon = function () {
    return this.isComingSoon;
  };

  TestType.prototype.getDisplayType = function () {
    return this.displayType;
  };

  TestType.prototype.getImageDetectionUrl = function () {
    return this.imageDetectionUrl;
  };

  TestType.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  TestType.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  TestType.prototype.getParasiteSpecies = function () {
    return this.parasiteSpecies;
  };

  TestType.prototype.getAnimalSpecies = function () {
    return this.animalSpecies;
  };

  TestType.prototype.getRecipes = function () {
    return this.recipes;
  };

  TestType.prototype.getInventoryTypes = function () {
    return this.inventoryTypes;
  };

  TestType.prototype.getTestKitId = function () {
    return this.testKitId;
  };

  TestType.prototype.getTestKit = function () {
    return this.testKit;
  };

  TestType.prototype.getCorrectionFactor = function () {
    return this.correctionFactor;
  };

  TestType.prototype.getCount = function () {
    return this.count;
  };

  TestType.prototype.getOrder = function () {
    return this.order;
  };

  TestType.prototype.getIsIndependentType = function () {
    return this.isIndependentType;
  };

  TestType.prototype.getIsResultsType = function () {
    return this.isResultsType;
  };

  TestType.prototype.getParentTestTypeId = function () {
    return this.parentTestTypeId;
  };

  TestType.prototype.getParentTestType = function () {
    return this.parentTestType;
  };

  TestType.prototype.getHasIncubation = function () {
    return this.hasIncubation;
  };

  TestType.prototype.getJointChildTestTypes = function () {
    return this.jointChildTestTypes;
  };

  TestType.prototype.getTestTypeJoin = function () {
    return this.TestTypeJoin;
  };

  TestType.prototype.getChildTestTypes = function () {
    return this.childTestTypes;
  };

  TestType.prototype.getZIndex = function () {
    return this.zIndex;
  };

  TestType.prototype.getTestTypeGroup = function () {
    return this.testTypeGroup;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  TestType.prototype.showEpg = function () {
    return this.getDisplayType() === 'EPG';
  };

  TestType.prototype.showPercentage = function () {
    return this.getDisplayType() === 'PERCENTAGE';
  };

  TestType.prototype.showPresenceOf = function () {
    return this.getDisplayType() === 'PRESENCE_OF';
  };

  return TestType;
}();

var _default = TestType;
exports.default = _default;